import React from 'react';
import PortfolioContainer from '../Navbar';
// import Hero from './Pages/Hero'
export default function Header() {
  return (
    <div>
      <PortfolioContainer/>
    </div>
  )
}
